// eslint-disable-next-line import/no-cycle
import AnalyticTable from "./AnalyticTable";

export default AnalyticTable;
